export const CONTACT = {
  PHONE: '+31640727125',
  PHONE_FORMATTED: '+31 6 40727125',
  EMAIL: 'info@power-fix-solutions.com',
  ADDRESS: 'Ridderkerk vlietplein 131',
  KVK: '95077235',
};

export const CONTACT_URLS = {
  PHONE: 'tel:+31640727125',
  EMAIL: 'mailto:info@power-fix-solutions.com',
};
